export const containerInfoEntregas = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
}

export const formGroupTextValue = {
    fontWeight: 'bold'
}

export const formGroupTextValueSemDest = {
    ...formGroupTextValue,
    color: '#a1a1a1'
}

export const textAreaSx = {
    height: '120px',
    width: '100%'
}

export const sessaoFotos = {
    overflowX: 'auto',
    position: 'relative',
    whiteSpace: 'nowrap'
}

export const styleImg = {
    width: '202px',
    height: '198px',
    borderRadius: '5px',
    margin: '5px'
}
